module.exports = __webpack_public_path__ + "img/service-banner9.a3aae4b4.png";